'use client'

import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

type SectionSeparatorProps = {
  className?: string
}

export default function SectionSeparator({ className }: SectionSeparatorProps) {
  return (
    <div className={cn('px-4 md:px-8 lg:px-18', className)}>
      <Separator className="bg-white/10" />
    </div>
  )
}
